import React, { useRef, useMemo } from "react";
import { OnChangeValue } from "react-select";

import { CaretDown } from "shared/assets/icons";
import { IStatus } from "shared/types";

import { IconValueContainer, Option, Menu } from "./components";
import { SelectContainer, StyledActionSelect, StyledActionSelectPortal } from "./styles";

export interface IActionSelectOption {
  value: string;
  label: string;
  handleClick?: () => void;
  status?: IStatus;
  dataTestId?: string;
}

interface SelectProps {
  options: IActionSelectOption[];
  selectedOption?: OnChangeValue<IActionSelectOption, false>;
  onChange?: (value: any) => void;
  icon?: JSX.Element;
  prefix?: string;
  placeholder?: string;
  selectFirstOption?: boolean;
  dataTestId?: string;
}

export const ActionSelect: React.FC<SelectProps> = ({
  options,
  selectedOption,
  prefix,
  icon,
  placeholder = null,
  onChange,
  selectFirstOption,
  dataTestId,
  ...rest
}) => {
  const ref = useRef<any>();

  const currentValue = useMemo(() => {
    if (!selectedOption) {
      return selectFirstOption ? options[0] : null;
    }
    return selectedOption;
  }, [selectedOption, options, selectFirstOption]);

  return (
    <SelectContainer {...rest} data-testid={dataTestId}>
      <StyledActionSelectPortal />
      <StyledActionSelect
        options={options}
        isSearchable={false}
        components={{
          Placeholder: () => placeholder as any,
          ValueContainer: (props: any) => (
            <IconValueContainer {...props} icon={icon} prefix={prefix} />
          ),
          IndicatorSeparator: () => null,
          DropdownIndicator: () => <CaretDown />,
          Menu,
          Option,
        }}
        value={currentValue}
        onChange={(e: any) => {
          onChange && onChange(e);
        }}
        ref={ref}
        classNamePrefix={"action-select"}
        menuPortalTarget={document.body}
        tabSelectsValue={false}
        blurInputOnSelect
      />
    </SelectContainer>
  );
};
